import { db } from '@/firebase'

export default {

    getCruzados({ commit, rootState }) {
        let negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio).collection('cruzados').get()
            .then((res) => {
                commit('setCruzados', res.docs.map(doc => {
                    let aux = doc.data();
                    aux.id = doc.id;
                    return {
                        ...doc.data(),
                        id: doc.id
                    }
                }))
            })
    },
    addCruzado({ rootState }, cruz) {
        let negocio = rootState.app.negocioGest
        let id = cruz.id;
        delete cruz.id;
        var ref = null
        if (id) {
            ref = db.collection('negocios').doc(negocio).collection('cruzados').doc(id).set(cruz, { merge: true })
        } else {
            ref = db.collection('negocios').doc(negocio).collection('cruzados').add(cruz)
        }
        return ref;
    },
    changeActivo({ rootState }, payload) {
        const negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio).collection('cruzados')
            .doc(payload.id).get()
            .then((desc) => {
                var res = [];
                if (desc.exists) {
                    var ref = desc.ref;
                    return ref.set({ activo: payload.activo }, { merge: true })
                } else {
                    return Promise.reject("Cruzado no encontrado")
                }
            })
    }
}